import * as React from "react";
import {
  BODetailTopBar,
  BODetailTopBarItem
} from "app/components/BOComponents/BODetailTopBar/BODetailTopBar";
import { groupAuth } from "app/utils/authGroups";

const UserMessageDetailTopBar = ({
  userMessageId,
  showEdit
}: {
  userMessageId: string;
  showEdit: boolean;
}) => {
  return (
    <BODetailTopBar>
      <BODetailTopBarItem
        text="Summary"
        link={`/snapscan/ops/user_messaging/${userMessageId}/summary`}
      />
      {groupAuth.hasAccessGroup(["Ops/UserMessaging"]) && showEdit ? (
        <BODetailTopBarItem
          text="Edit"
          link={`/snapscan/ops/user_messaging/${userMessageId}/edit`}
        />
      ) : null}
    </BODetailTopBar>
  );
};

export default UserMessageDetailTopBar;
